export interface NavigationState {
    columnLengths: number[]
    col: number
    row: number
}

export function createNavigationState(
    columnLengths: number[],
    selection: { col: number; row: number } | null
): NavigationState {
    if (!selection) {
        return { columnLengths, col: -1, row: -1 }
    }
    return { columnLengths, col: selection.col, row: selection.row }
}

export function navigationStateToSelection(
    state: NavigationState
): { col: number; row: number } | null {
    if (state.col === -1 || state.row === -1) {
        return null
    }
    return { col: state.col, row: state.row }
}

type Direction = 'up' | 'down' | 'left' | 'right'

export function navigate(
    state: NavigationState,
    direction: Direction
): NavigationState {
    const { columnLengths, col, row } = state
    const numColumns = columnLengths.length

    switch (direction) {
        case 'down': {
            if (col === -1) {
                for (let c = 0; c < numColumns; c++) {
                    if (columnLengths[c] > 0) {
                        return { columnLengths, col: c, row: 0 }
                    }
                }
                return state
            }
            if (row < columnLengths[col] - 1) {
                return { columnLengths, col, row: row + 1 }
            }
            return state
        }

        case 'up': {
            if (col === -1) {
                return state
            }
            if (row > 0) {
                return { columnLengths, col, row: row - 1 }
            }
            return { columnLengths, col: -1, row: -1 }
        }

        case 'right': {
            if (col === -1) {
                for (let c = 0; c < numColumns; c++) {
                    if (columnLengths[c] > 0) {
                        return { columnLengths, col: c, row: 0 }
                    }
                }
                return state
            }
            for (let c = col + 1; c < numColumns; c++) {
                if (columnLengths[c] > 0) {
                    const newRow = Math.min(row, columnLengths[c] - 1)
                    return { columnLengths, col: c, row: newRow }
                }
            }
            return state
        }

        case 'left': {
            if (col === -1) {
                return state
            }
            for (let c = col - 1; c >= 0; c--) {
                if (columnLengths[c] > 0) {
                    const newRow = Math.min(row, columnLengths[c] - 1)
                    return { columnLengths, col: c, row: newRow }
                }
            }
            return { columnLengths, col: -1, row: -1 }
        }
    }
}
